// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-shypcx-tyShypxc-index-main_right_content-3kwwu","table":"components-tjcx-shypcx-tyShypxc-index-table-2U-3l"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/shypcx/tyShypxc/index.css
// module id = 2316
// module chunks = 0